import { IAppConfiguration } from '../cemexng2components/components/app-configuration';

import dashboard from './dashboard';
import financialDocumentsTables from './financial-documents-tables';
import financialDocuments from './financial-documents';
import disputes from './disputes';
import disputesTables from './disputes-tables';
import pendingOrders from './pending-orders';
import payments from './payments';
import creditRequest from './credit-request';
import documentCenter from './document-center';
import paymentHistory from './payment-history';
import reports from './reports';
import cashSales from './cash-sales';
import businessSchedule from './business-schedule';
import salesOffice from './sales-office';
import leanRelease from './lien-release';
import ipcCompanySelector from './ipc-company-selector';
import core from './core';

export default [].concat(
  dashboard,
  financialDocuments,
  financialDocumentsTables,
  disputes,
  disputesTables,
  pendingOrders,
  payments,
  creditRequest,
  documentCenter,
  paymentHistory,
  reports,
  cashSales,
  businessSchedule,
  salesOffice,
  ipcCompanySelector,
  leanRelease,
  core,
  [

    {
      feature: 'download-documents.not-found-default-note',
      country:
        ['MX', 'US', 'CO', 'GB', 'DE', 'PA', 'CR', 'NI', 'SV', 'CZ', 'ES', 'LV', 'GT', 'DO', 'PR', 'PE', 'IL', 'PH', 'PL'],
    },
    {
      feature: 'download-documents.not-found-disclaimer-note',
      country: ['FR'],
    },
    {
      feature: 'special-invoice-credit-request',
      country: ['MX']
    }
  ]
);
